<template>
  <div>
    <WorkflowBuilder :workflowID="this.workflowID"/>
  </div>
</template>

<script>
/* eslint-disable */

import Multiselect from "vue-multiselect";
import { mapState, mapActions, mapMutations } from 'vuex';
import ErrorDisplay from "@/components/ErrorDisplay/ErrorDisplay";
import mixin from '../../mixin.js';
import WorkflowBuilder from './components/WorkflowBuilder';

export default {
  name: "CreateWorkflow",
  components: { WorkflowBuilder, Multiselect, ErrorDisplay },  
  mixins: [mixin],
  props: ['workflowID'],

  created() {
    if(this.allSettings)
        this.init();
  },

  data() {
    return {
      workflows: []
    };
  },
  methods: {
    ...mapActions('alert', ['setDismissSuccessCountDown', 'setErrored', 'setMessage']),
    ...mapActions('workflow', ['getAllWorkflows', 'deleteWorkflow']),

    async init() {
      if(this.workflows.length === 0)
        this.workflows = await this.getAllWorkflows({siteID: this.siteID});
    },

  },

  computed: {
  },

  watch: {
    allSettings(newValue, oldValue) {        
      //console.log(`watch changed. Old value: ${JSON.stringify(oldValue)}, \n New value: ${JSON.stringify(newValue)}`);
      if(!oldValue) {
        this.init();
      }        
    }
  }

};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="./CreateWorkflow.scss" lang="scss" />
